module.exports = __webpack_public_path__ + "static/media/sidebarlogo.6e9a5705.png";